import { LazyImageFallback } from 'components/map/various/LazyImageFallback';
import { LazyImageGenerator } from 'components/map/various/LazyImageGenerator';
import { ServerSync } from 'components/map/various/ServerSync';
import { WorldMapEdit } from 'components/map/WorldMapEdit';
import { useGetMap } from 'hooks/map/useGetMap';
import { useContext, useEffect, useState } from 'react';
import { CtxEdit } from 'session/ctxEdit';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
    children?: React.ReactNode;
    worldMapId: string;
}

export const MapLayout = (props: Props): JSX.Element => {
    const ctxEdit = useContext(CtxEdit);
    const [mapRef, setMapRef] = useState<HTMLDivElement>();

    useGetMap(props.worldMapId);

    useEffect(() => {
        if (mapRef) {
            ctxEdit.setBoundingExtra({
                y: mapRef?.getBoundingClientRect().top,
                x: mapRef?.getBoundingClientRect().left
            });
        }
    }, [mapRef]);

    if (!ctxEdit.map?.worldMapId) {
        return null;
    }

    return (
        <S_MapLayout className={props.className}>
            <S_Content ref={(newRef) => setMapRef(newRef)}>
                <LazyImageGenerator />
                <LazyImageFallback mapRef={ctxEdit.mapRef} markers={ctxEdit.worldMarkers} />
                <WorldMapEdit mapId={props.worldMapId} markers={ctxEdit.worldMarkers} />
                <ServerSync />
                {props.children}
            </S_Content>
        </S_MapLayout>
    );
};

const S_MapLayout = styled.div`
    width: 100%;
    flex: 1;
    display: flex;
    flex-shrink: 0;
    flex-direction: column;
    position: relative;
`;

const S_Content = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
`;
